import React, { useCallback, useEffect, useState } from "react";
import SearchScreenTableWrapper from "./SearshScreenTableWrapper";
import PropTypes from "prop-types";
import { useAvailablePortfolios } from "hooks/useCommonBenchmarks";
import { GET_SEARCH_FILTERS_TABLE_DATA } from "hooks/useApi";
import useApi from "hooks/useApi/useApi";
import CheckboxGrid from "./CheckboxGrid";
import FilterComponentsGrid from "./FilterComponentsGrid";
import { Button, Box } from "@material-ui/core";
import moment from "moment";

const STORAGE_KEY_PREFIX = "filterComponentState_";
const START_DATE_KEY = "startDate";
const END_DATE_KEY = "endDate";

const SearchScreen = ({ data }) => {
  const [name, setName] = useState("");
  const [options, isError, isLoading] = useAvailablePortfolios();
  const [startDateState, setStartDateState] = useState(() => {
    const storedStartDate = sessionStorage.getItem(START_DATE_KEY);
    return storedStartDate ? new Date(storedStartDate) : new Date("2000-01-01");
  });
  const [endDateState, setEndDateState] = useState(() => {
    const storedEndDate = sessionStorage.getItem(END_DATE_KEY);
    return storedEndDate
      ? new Date(storedEndDate)
      : new Date(new Date().getFullYear(), new Date().getMonth(), 1);
  });
  const [chosenFilters, setChosenFilters] = useState([]);
  const [chosenCheckboxes, setChosenCheckboxes] = useState('');
  const [responseState, makeRequest] = useApi();

  const filtersListsDropdowns = data.filtersListsDropdowns;

  const handleNameChange = (event) => {
    setName(event.target.value);
  };

  const handleSetStartDate = (newDate) => {
    const adjustedDate = new Date(newDate.getFullYear(), newDate.getMonth(), 1);
    setStartDateState(adjustedDate);
    sessionStorage.setItem(START_DATE_KEY, adjustedDate.toISOString());
  };

  const handleSetEndDate = (newDate) => {
    const adjustedDate = new Date(newDate.getFullYear(), newDate.getMonth(), 1);
    setEndDateState(adjustedDate);
    sessionStorage.setItem(END_DATE_KEY, adjustedDate.toISOString());
  };

  const handleFilterChange = useCallback(
    (filterName, memberText) => {
      setChosenFilters((prevChosenFilters) => {
        const updatedFilters = prevChosenFilters.map((filter) => {
          if (filter.filterName === filterName) {
            return { ...filter, memberText };
          }
          return filter;
        });
        return updatedFilters;
      });
    },
    [setChosenFilters]
  );

  useEffect(() => {
    const initialFilters = filtersListsDropdowns.flatMap((filter) => {
      const memberText =
        sessionStorage.getItem(`${STORAGE_KEY_PREFIX}${filter.name}`) ||
        (filter.filtersListMembers.length > 0
          ? filter.filtersListMembers[0].memberText
          : "");

      return memberText !== "" ? { filterName: filter.name, memberText } : [];
    });
    setChosenFilters(initialFilters);
  }, [data]);

  const handleSave = () => {
    let chosenFiltersString = chosenFilters
      .filter(({ memberText }) => memberText !== null)
      .map(({ filterName, memberText }) => `${filterName},${memberText}`)
      .join(",");

    const nameParam = name.trim() !== "" ? `,Name,${name.trim()}` : "";
    chosenFiltersString += nameParam;

    const startDate = moment(startDateState).format("YYYY-MM-DD");
    const endDate = moment(endDateState).format("YYYY-MM-DD");
    
    const apiParams = GET_SEARCH_FILTERS_TABLE_DATA({
      startDate,
      endDate,
      filters: chosenFiltersString,
      searchScreenBoxes: chosenCheckboxes,
    });
    makeRequest(apiParams);
  };

  if (!data) {
    return null;
  }

  return (
    <Box height="100%" minHeight={0} paddingBottom='20px'>
      <FilterComponentsGrid
        filters={filtersListsDropdowns}
        startDateState={startDateState}
        handleSetStartDate={handleSetStartDate}
        endDateState={endDateState}
        handleSetEndDate={handleSetEndDate}
        name={name}
        handleNameChange={handleNameChange}
        options={options}
        handleFilterChange={handleFilterChange}
      />

      <CheckboxGrid
        searchFiltersCheckboxes={data.searchFiltersCheckboxes}
        handleCheckboxChange={setChosenCheckboxes}
      />
      <Box
        display="flex"
        justifyContent="center"
        marginTop="20px"
        marginBottom="20px"
        width="100%"
      >
        <Button variant="contained" color="primary" onClick={handleSave}>
          Search
        </Button>
      </Box>
      {responseState && (responseState.data || responseState.isError || responseState.isLoading) && <SearchScreenTableWrapper state={responseState} />}
    </Box>
  );
};

SearchScreen.propTypes = {
  data: PropTypes.object.isRequired,
};

export default SearchScreen;
